import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=f92836fe&scoped=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"
import style0 from "./Register.vue?vue&type=style&index=0&id=f92836fe&prod&lang=scss"
import style1 from "./Register.vue?vue&type=style&index=1&id=f92836fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92836fe",
  null
  
)

export default component.exports